/**
 * FinancialReportsCtrl controller
 *
 * @class FinancialReportsCtrl
 * @memberof mwApp/FinancialReportsCtrl
 * @see mwApp/FinancialReportsCtrl
 * @mixes mwApp/common.mixin:tabsCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/FinancialReportsCtrl.controller:FinancialReportsCtrl
 */
/* @ngInject */
export default function FinancialReportsCtrl ($scope, $window, authSvc) {
  var vm = this
  vm.mixes = authSvc.hasAccess('createFinancialReport')
    ? [['tabsCtrlMixin', '', 'reports_list', 'generated_reports']]
    : [['tabsCtrlMixin', 'reports_list', 'generated_reports']]

  /**
   * Methods to change tab
   *
   * @memberof mwApp/financialReports.controller:FinancialReportsCtrl
   */
  vm.toChangeTab = function (tabName) {
    $scope.$broadcast(`dispatch: ${tabName}`)
  }
}
